import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader-content">
        <div className="preloader-logo">
         ARCHMIPLAN
        </div>
      </div>
    </div>
  );
};

export default Preloader;